export default __webpack_public_path__ + "static/media/2_0008.efff6d74.webp";